// extracted by mini-css-extract-plugin
export var closeButton = "_i0-2";
export var closeButtonIcon = "_i0-3";
export var lightboxContent = "_i0-1";
export var lightboxOverlay = "_i0-0";